module.exports = __webpack_public_path__ + "static/video-1630f0933f28ae1739ca044d84d59757.jpg";